import axios from "axios";
import {API_CAR_INSURANCE_QUOTE_NEW} from "@constants/next-api-endpoints";
import {BACKEND_ACCIDENT_MANAGEMENT_CLAIM_NEW} from "@constants/laravel-backend-endpoints";

export const insuranceFormOnSubmit = async function ({
   setIsSubmissionProcessing,
   executeRecaptcha,
   setSubmissionErrorMsg,
   formData,
   setSubmissionSuccessMsg,
   setSubmissionProcessingMsg,
   setServerValidationErrors,
   endPointUrl,
   setFormData,
   resetForm = true
}) {
   setIsSubmissionProcessing(true);
   
   // Make sure this line is present
   const token = await executeRecaptcha('form_submit');
   //console.log('Recaptcha token:', token); // Log the token to verify
   
   if (!token) {
      setSubmissionErrorMsg('Recaptcha token is missing.');
      setIsSubmissionProcessing(false);
      return;
   }
   
   
   try {
      
      /*alert(`${formData.recaptchaToken}`);
      return;*/
      
      const response = await axios.post(
         endPointUrl,
         {
            ...formData,
            recaptchaToken: token,
         }
      );
      
      let data = response.data;
      
      setIsSubmissionProcessing(false);
      
      setSubmissionSuccessMsg(data.message ? data.message : 'Thank you for the submission!');
      
      if(resetForm) {
         setFormData({});
      }
      
   } catch (error) {
      
      setIsSubmissionProcessing(false);
      
      setSubmissionProcessingMsg(''); // Clear loading message
      setSubmissionSuccessMsg('');
      
      if (error.response) {
         
         /**
          * Validation errors via laravel validation ...
          */
         
         if (error.status === 422) {
            
            let errors = error.response.data.errors;
            
            let temp = [];
            
            for (const errorsKey in errors) {
               if (!errors.hasOwnProperty(errorsKey)) {
                  continue;
               }
               
               temp.push(errors[errorsKey]['message']);
               
            }
            
            setServerValidationErrors(temp);
            
         } else {
            
            if (error.response.status === 400) {
               setSubmissionErrorMsg(error.response.data.error);
            } else {
               setSubmissionErrorMsg(`Error: ${error.response.status} - ${error.response.data.message || 'An error occurred.'}`);
            }
            
            
         }
         
      } else if (error.request) {
         setSubmissionErrorMsg('Error: No response from server.');
      } else {
         
         setSubmissionErrorMsg('Error: An unexpected error occurred.');
      }
   }
};